import React from 'react'
import PropTypes from 'prop-types'
import { TrayWrapper, UpsellWrapper } from '../RetailItinerary.styles'
import { Banner, Flex, Shimmer, Text } from 'pcln-design-system'
import { UpsellTrayCard } from './UpsellTrayCard'

const UpsellTrayContainer = ({
  upsells,
  isLoading,
  error,
  priceColor,
  fareBrandBoxTexts,
  handleUpsellOptionClick,
  gaTagUpsellTileClick,
  airline,
}) => {
  if (isLoading) {
    return (
      <TrayWrapper
        color='background.light'
        borderRadius='xl'
        rounded='bottom'
        p={3}
        data-testid='upsell-skeleton'
      >
        {[1, 2, 3].map((_, index) => (
          <UpsellWrapper borderRadius='xl' p={3} isShimmer key={index}>
            <Flex
              maxWidth={[null, null, null, null, '135px', 'unset']}
              flexDirection='column'
              alignItems='center'
            >
              <Shimmer animationWidth={50} width={3 / 4} />
              <Shimmer mt={2} width={3 / 4} />
              <Shimmer mt={3} width={1 / 2} height='70px' />
            </Flex>
          </UpsellWrapper>
        ))}
      </TrayWrapper>
    )
  }
  if (error) {
    return (
      <TrayWrapper
        color='background.light'
        borderRadius='xl'
        rounded='bottom'
        p={3}
        data-testid='upsell-error-banner'
      >
        <Banner
          bg='lightRed'
          text={
            <Text color={'text.base'}>
              <Text.span bold> Something went wrong </Text.span> We’re sorry, we did not find any add-ons for
              this flight.
            </Text>
          }
          p={3}
          showIcon={false}
          textAlign='center'
          borderRadius='xl'
        />
      </TrayWrapper>
    )
  }

  return (
    <TrayWrapper color='background.light' borderRadius='xl' rounded='bottom' p={3}>
      {upsells?.map((upsell, index) => {
        return (
          <UpsellWrapper
            borderRadius='xl'
            p={3}
            onClick={(e) => {
              handleUpsellOptionClick(e, upsell.priceKey)
              gaTagUpsellTileClick(index, upsell.name, airline?.name, upsells.length)
            }}
            key={upsell.name}
            data-testid={`upsell-tray-card-${index}`}
          >
            <UpsellTrayCard upsell={upsell} priceColor={priceColor} fareBrandBoxTexts={fareBrandBoxTexts} />
          </UpsellWrapper>
        )
      })}
      {upsells?.length === 1 && (
        <Flex flexDirection='column' justifyContent='center'>
          <Text fontSize={1} bold textAlign='center'>
            We’re sorry, we did not find any add-ons for this flight.
          </Text>
        </Flex>
      )}
    </TrayWrapper>
  )
}

UpsellTrayContainer.propTypes = {
  upsells: PropTypes.array,
  isLoading: PropTypes.bool,
  priceColor: PropTypes.string,
  fareBrandBoxTexts: PropTypes.array,
  error: PropTypes.bool,
  handleUpsellOptionClick: PropTypes.func,
  gaTagUpsellTileClick: PropTypes.func,
  airline: PropTypes.object,
}

export { UpsellTrayContainer }
